import { combineReducers } from 'redux';
import historyReducer from './history';
import authReducer from './auth';
import adminReducer from './admin';
import devicesReducer from './devices';
import messagesReducer from './messages';
import patientsReducer from './patients';

const rootReducer = combineReducers({
  devices: devicesReducer,
  patients: patientsReducer,
  history: historyReducer,
  messages: messagesReducer,
  auth: authReducer,
  admin: adminReducer,
});

export default rootReducer;
